import AppLoader from './Loader';

export default AppLoader;